import { ITranslations } from './translations.interface'

const privacyPolicyLink = 'https://www.nl.travelski.com/instit-privacy-verklaring'
const partnersLink = `<a href='${privacyPolicyLink}' target='_blank' rel='noopener'>onze partners</a>`

const translations: ITranslations = {
  navbar: {
    greeting: 'Hallo',
    confirmed: 'Reserveringen',
    quotes: 'Zoekopdrachten',
    profile: 'Profiel',
    logout: 'Uitloggen',
  },
  loginRegister: {
    login_page_title: 'Klantaccount',
    log_in_or_register: 'Log in of registreer om te boeken',
    login_register: 'Inloggen / registreren',
    email_not_valid: 'Je e-mailadres is onjuist',
    user_info_mandatory_field: 'Verplicht veld',
    user_info_invalid_phone: 'Ongeldig formaat.',
    user_info_invalid_phone_length:
      'Ongeldig formaat. Telefoonnummer moet {count} cijfers bevatten.',
    user_info_invalid_phone_length_range:
      'Ongeldig formaat. Telefoonnummer moet {min} tot {max} cijfers bevatten.',
    user_info_invalid_phone_length_start_zero:
      'Ongeldig formaat. Telefoonnummer moet {count} cijfers bevatten en beginnen met 0.',
    new_password_forgot_password: 'Wachtwoord vergeten?',
    new_password_create_new_password: 'Maak een nieuw wachtwoord aan',
    new_password1: 'Nieuw wachtwoord',
    new_password2: 'Bevestig je wachtwoord',
    user_info_forgot_password: 'Wachtwoord vergeten?',
    user_info_already_have_account: 'Heb je al een account?',
    user_info_enter_email: 'Klik hier om jouw wachtwoord aan te passen',
    user_info_email_sent:
      'Een link om je wachtwoord te resetten is verzonden naar',
    user_info_new_password: 'Voer je nieuwe wachtwoord in',
    send: 'Stuur',
    validate: 'Bevestig',
    i_want_to_register: 'Account aanmaken',
    i_want_to_login: 'Inloggen',
    new_password_succes: 'Je wachtwoord is aangepast',
    login: 'Inloggen',
    user_info_your_informations: 'Jouw gegevens',
    contacts_first_name: 'Voornaam',
    contacts_last_name: 'Achternaam',
    contacts_email: 'E-mail',
    contacts_other_email: 'Inloggen met een andere e-mail',
    contacts_password1: 'Wachtwoord',
    contacts_password2: 'Bevestig je wachtwoord',
    contacts_password_format: 'Je wachtwoord moet',
    contacts_password_format_lenght: 'Minstens 8 tekens bevatten',
    contacts_password_format_lowercase: 'Minstens 1 kleine letter bevatten',
    contacts_password_format_uppercase: 'Minstens 1 hoofdletter bevatten',
    contacts_password_format_number: 'Minstens 1 cijfer bevatten',
    contacts_password_format_character:
      'Minstens 1 speciaal teken bevatten (# ; @ ; $ ...)',
    contacts_passwords_dont_match: 'Het wachtwoord komt niet overeen',
    contacts_email_is_not_valid: 'Het e-mailadres is niet geldig',
    user_info_to_contact_you: 'Neem contact op',
    contacts_address: 'Adres',
    contacts_city: 'Stad',
    contacts_country: 'Land',
    contacts_postal_code: 'Postcode',
    contacts_phone_number: '00 00 00 00 00',
    contacts_subscribe_newsletter:
      'Ik wil me graag abonneren op de Travelski.nl nieuwsbrief en profiteren van aanbiedingen!',
    contacts_accept_conditions1: 'Ik heb gelezen en accepteer de',
    contacts_accept_conditions2: 'Algemene Voorwaarden',
    contacts_accept_conditions3:
      'en ik ben geïnformeerd dat ik geen herroepingsrecht heb.',
    update_my_details: 'Mijn gegevens bijwerken',
    continue_with_these_contacts: 'Doorgaan met deze informatie',
    user_info_create_account: 'Maak een account aan',
    user_info_is_it_first_time: 'Ga je voor het eerst op reis met Travelski?',
    contacts_incorrect_credentials: 'Jouw inloggegevens zijn onjuist',
    error_wrong_email: 'Het ingevoerde e-mailadres is ongeldig. Controleer de gegevens en probeer opnieuw.',
    register_call_center_modal_title: 'Hulp nodig?',
    register_call_center_modal_message: 'Ons callcenter is bereikbaar tijdens de volgende openingstijden om je te helpen je boeking af te ronden.',
    register_call_center_modal_phone: 'Telefoon',
    register_call_center_modal_opening_hours: 'Openingstijden callcenter',
    register_call_center_modal_call_button: 'Bel het callcenter',
    mister: 'Dhr.',
    madam: 'Mevr.',
    link_expired: 'Link is verlopen',
    text_resend_link:
      'De link voor het herstellen van het wachtwoord is verlopen. Klik op de knop hieronder om een nieuwe te ontvangen.',
    button_resend_link: 'Link opnieuw verzenden',
    keepInTouch: {
      title: 'Blijf in contact',
      emailDealsLabel: 'E-maildeals en gepersonaliseerde content',
      emailDealsDesc:
        'Exclusieve aanbiedingen, prijsverlagingen, vroegboekvoordelen en tracking van e-mailopeningen.',
      partenairesLabel: 'Partnervoordelen',
      partenairesDesc: `Nieuwigheden en voordelen van ${partnersLink} (verzonden door travelski)`,
      personalize: 'Gedetailleerde aanpassingen',
      personalizeTitle: 'Communicatievoorkeuren',
      sectionDealsTitle: 'Travelski-aanbiedingen',
      sectionDealsIntro:
        'Exclusieve kortingen, vroegboekvoordelen en prijsverlagingen. Uitschrijven kan op elk moment.',
      sectionPartnersTitle: 'Voordelen van onze partners',
      sectionPartnersIntro: `Nieuws, inspiratie en exclusieve voordelen van de partners van Compagnie des Alpes en Travelski. Om onze communicatie relevanter te maken, kunnen we meten of e-mails worden geopend. Alle berichten worden verzonden door Travelski. Je gegevens blijven bij ons en worden nooit gedeeld met ${partnersLink}, zoals Futuroscope, Les Arcs of La Plagne.`,
      sectionTrackingTitle: 'Gepersonaliseerde e-mails',
      sectionTrackingIntro:
        'Door het gebruik van trackingpixels kunnen we vaststellen of een e-mail werd geopend. Zo beperken we onnodige herinneringen, stemmen we onze communicatie beter af op je interesses en meten we de prestaties van onze campagnes. Je kunt deze toestemming op elk moment met één klik intrekken via een nieuwsbrief of je klantenzone.',
      switchEmail: 'E-mail',
      switchEmailDesc:
        'Het ideale kanaal om aanbiedingen, nieuwtjes en prijsalerts te ontvangen.',
      switchTracking: 'E-mailtracking',
      switchTrackingDesc:
        'Meten of een e-mail geopend werd via een trackingpixel.',
      switchPartenaires: 'Partnercommunicatie (e-mail)',
      switchPartenairesDesc: `Ontvang exclusieve aanbiedingen en nieuws van ${partnersLink}. Alle communicatie wordt verzonden door Travelski. Je gegevens blijven bij ons en worden niet gedeeld met ${partnersLink}.`,
      switchSms: 'SMS',
      switchSmsDesc:
        'Korte herinneringen en belangrijke updates over je boeking of aanbiedingen.',
      save: 'Opslaan',
      back: 'Terug',
    },
  },
  reservations: {
    pageTitle: 'Mijn reserveringen',
    participant: 'deelnemer | deelnemers',
    until: 'tot',
    pastBookings: 'Mijn eerdere verblijven',
    noBooking: 'Geen reservering ... voorlopig!',
    timeToChoose:
      'Waar breng je je volgende wintersportvakantie door? Het is tijd om te kiezen!',
    search: 'Start zoeken',
    reference: 'Referentienummer',
    viewDetails: 'Details bekijken',
    payBalance: 'Saldo betalen',
    prestId: 'Accommodatiereferentie:',
    participantInfo: 'Deelnemerinformatie invullen',
    summaryTitle: 'Overzicht van mijn reservering',
    missingTravellerInfoWarning: 'Informatie van deelnemers vereist',
    nextStay: 'Mijn volgende verblijf',
    eurostarTitle: 'Haal je Eurostar-tickets op',
    eurostarBody:
      'Je treintickets zijn beschikbaar op de Eurostar-website zodra je reizigersgegevens zijn ingevuld. Log in met je Eurostar-boekingsreferentie en achternaam, en vul de gevraagde informatie in om je e-tickets te openen.',
    eurostarReference: 'Eurostar-referentie:',
    eurostarCta: 'Mijn Eurostar-tickets ophalen',
    formula: 'Formule',
    equipment: 'Materiaal',
    accommodation: 'Accommodatie',
    skipass: 'Skipas',
    train: 'Trein',
    flight: 'Vliegtuig',
    transfer: 'Transfer',
    taxi: 'Taxi',
    bus: 'Bus',
    funicular: 'Kabelbaan',
    serviceHours24: 'Service 24/7',
    luggage: 'Bagage',
    luggageBothWays: 'beide richtingen',
    luggageOutboundOnly: 'alleen heen',
    luggageInboundOnly: 'alleen terug',
    transport: 'Trein + Transfer',
    outbound: 'Heenreis:',
    return: 'Terugreis:',
    class: 'klasse',
    skipassShort: 'Korte skipas',
    equipmentShort: 'Kort verblijf materiaal',
    FeeIncluded: 'Servicekosten inbegrepen',
    viewQuote: 'Bekijk de accommodatiegegevens',
    helmet: 'Helm',
    option: 'Opties',
    proceedToAvailability: 'Bekijk beschikbaarheid van de accommodatie',
    total: 'Totaal',
    reserve: 'Reserveren',
    payDeposit: 'Aanbetaling betalen',
    reserveActionsDepositHint: 'Verder op de boekingssite',
    reserveActionsPaymentsSection: 'Te betalen betaallinks',
    reserveActionsPaymentLinkTitle: 'Betaallink',
    paymentLinkTitle: 'Betaallink {n}',
    echeanceTitle: 'Betaling {n}',
    echeanceTitleSingle: 'Geplande betaling',
    reserveActionsDueBy: 'vóór {date}',
    payPaymentLink: 'Betaal {amount}',
    payPaymentLinkWithDate: 'Betaal {amount} (vóór {date})',
    payPaymentLinkInstalment: 'Betaallink {n} betalen — {amount}',
    payPaymentLinkInstalmentWithDate:
      'Betaallink {n} betalen — {amount} (vóór {date})',
    reserveActionsTitle: 'Wat wilt u doen?',
    iresaPendingNotice:
      'Uw boeking wordt overgezet naar iResa. Sommige acties zijn tijdelijk mogelijk niet beschikbaar.',
    cancel: 'Annuleren',
  },
  documents: {
    title: 'Reisdocumenten',
    'booking-confirmation': 'Boekingsbevestiging',
    'booking-confirmation-available': 'Beschikbaar',
    'booking-confirmation-flight': 'Boekingsbevestiging',
    'booking-confirmation-flight-available': 'Beschikbaar',
    'booking-confirmation-train': 'Boekingsbevestiging',
    'booking-confirmation-train-available': 'Beschikbaar',
    vouchers: 'Reisvouchers',
    'vouchers-available': 'Beschikbaar 10 dagen voor het verblijf',
    invoice: 'Definitieve factuur',
    'invoice-available': 'Beschikbaar na het verblijf',
    other: 'Andere documenten',
    'other-available': 'Beschikbaar',
    insurance: 'Annuleringsverzekering',
    'insurance-available': 'Beschikbaar',
    'cancellation_insurance_certificate': 'Verzekeringsdocument',
    'cancellation_insurance_certificate-available': 'Beschikbaar',
    cancellation_insurance_certificatev2: 'Verzekeringsdocument',
    'cancellation_insurance_certificatev2-available': 'Beschikbaar',
    'insurance-skieur': 'Skiër Verzekering',
    'insurance-skieur-available': 'Beschikbaar',
    'insurance-annulation': 'Zen Annuleringsverzekering',
    'insurance-annulation-cosog': 'Garantie annulation',
    'insurance-annulation-available': 'Beschikbaar',
    'insurance-annulation-cosog-available': 'Beschikbaar',
    'flight_tickets': 'Vliegtickets',
    'flight_tickets-available': 'Beschikbaar',
    'flight_tickets_aller': 'Vliegtickets (heenreis)',
    'flight_tickets_aller-available': 'Beschikbaar',
    'flight_tickets_retour': 'Vliegtickets (terugreis)',
    'flight_tickets_retour-available': 'Beschikbaar',
    'flight_tickets_change': 'Vlucht wijziging',
    'flight_tickets_change-available': 'Beschikbaar',
    'skier_insurance_certificate': 'Skiërsverzekeringscertificaat',
    'skier_insurance_certificate-available': 'Beschikbaar',
    'altibus_ticket_aller': 'Bustickets (heenreis)',
    'altibus_ticket_aller-available': 'Beschikbaar',
    'altibus_ticket_retour': 'Bustickets (terugreis)',
    'altibus_ticket_retour-available': 'Beschikbaar',
    'bensbus_ticket': 'Bustickets',
    'bensbus_ticket-available': 'Beschikbaar',
    'bensbus_ticket_aller': 'Bustickets (heenreis)',
    'bensbus_ticket_aller-available': 'Beschikbaar',
    'bensbus_ticket_retour': 'Bustickets (terugreis)',
    'bensbus_ticket_retour-available': 'Beschikbaar',
    'tne_eticket_aller': 'Treintickets (heenreis)',
    'tne_eticket_aller-available': 'Beschikbaar',
    'tne_eticket_retour': 'Treintickets (terugreis)',
    'tne_eticket_retour-available': 'Beschikbaar',
    download: 'Downloaden',
    claimTitle: 'Om een claim in te dienen en de voortgang te volgen',
    myInsuredArea: 'Mijn verzekerde gebied',
    noDocuments: 'Geen documenten beschikbaar voor deze reservering.',
  },
  
  payments: {
    title: 'Saldo betaling',
    flexProduct: 'Flex',
    flexTitle: 'Flexibiliteit',
    flexDescription: ' Aan annuleren en wijzigen kunnen kosten verbonden zijn.',
    fixedProduct: 'Fix',
    fixedTitle: 'De beste prijs',
    fixedDescription: 'Wijzigen of restitutie niet mogelijk.',
    totalPrice: 'Totaal',
    depositToPay: 'Aanbetaling te betalen',
    leftToPay: 'Restant saldo',
    totalPaid: 'Betaald bedrag (aanbetaling)',
    termsAndConditions: 'Algemene voorwaarden',
  },
  travellers: {
    title: 'Deelnemers',
    age: 'Leeftijd',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    modifyInformation: 'Informatie aanpassen',
    modifyNotAllowedMessageBefore: 'Om de gegevens van uw reizigers te wijzigen, neem contact op met de klantenservice via support.uk@travelski.com (er kunnen kosten van toepassing zijn)',
    modifyNotAllowedMessageAfter: '(er kunnen kosten van toepassing zijn)',
    traveller: 'Deelnemer',
    panelIntro:
      'Vul de namen, voornamen en leeftijden van elke deelnemer in voor de beste tarieven.',
    yearsOld: 'jaar',
  },
  needHelp: {
    title: 'Hulp nodig?',
    description:
      'Twijfel? Advies nodig? Onze experts staan tot uw beschikking.',
    contact: 'Neem contact op',
  },
  panels: {
    confirm: 'Bevestig je selectie',
  },
  errorMessages: {
    fieldMandatory: 'Verplicht veld',
    atLeastOne18: 'Minstens één reiziger moet 18 jaar zijn',
    updateUserInfo: 'Gebruikersinformatie kon niet worden bijgewerkt',
    changePassword: 'Wachtwoord wijzigen mislukt',
    fetchBookings:
      'Er is een fout opgetreden bij het ophalen van de boekingen.',
    fetchLihes: 'Er is een fout opgetreden bij het ophalen van de lijnen.',
    fetchProductURL:
      'Er is een fout opgetreden bij het ophalen van de product-URL.',
    fetchServices: 'Er is een fout opgetreden bij het ophalen van de diensten.',
    getDocuments:
      'Er is een fout opgetreden bij het ophalen van de documenten.',
    login: 'Er is een fout opgetreden bij het inloggen.',
    logout: 'Er is een fout opgetreden bij het uitloggen.',
    newPassword:
      'Er is een fout opgetreden bij het instellen van het nieuwe wachtwoord.',
    refresh: 'Er is een fout opgetreden bij het vernieuwen van de sessie.',
    resetPassword:
      'Er is een fout opgetreden bij het resetten van het wachtwoord.',
    search: 'Er is een fout opgetreden bij het uitvoeren van de zoekopdracht.',
    register: 'Er is een fout opgetreden bij het registreren.',
    selectBooking:
      'Er is een fout opgetreden bij het selecteren van de boeking.',
    unselectBooking:
      'Er is een fout opgetreden bij het deselecteren van de boeking.',
    updateTraveller:
      'Er is een fout opgetreden bij het bijwerken van de reizigersinformatie.',
    validateTokens: '',
    handleBookingUILogin: '',
    handleCustomerUILogin: '',
  },
  successMessages: {
    resetPasswordSuccess: 'Wachtwoord succesvol gereset',
  },
  quotes: {
    pageTitle: 'Opgeslagen zoekopdrachten',
    noQuote: 'Geen opgeslagen zoekopdrachten ... voor nu!',
    timeToChoose:
      'Een verblijf gevonden dat je leuk vindt? Sla je zoekopdracht op en kom later terug om te boeken!',
  },
  profile: {
    pageTitle: 'Mijn profiel',
    settingsTitle: 'Accountinstellingen',
    infoTitle: 'Hulp nodig?',
    myInfo: 'Mijn gegevens',
    resetPassword: 'Wachtwoord',
    savePassword: 'Opslaan',
    savingPassword: 'Bezig met opslaan',
    currentPasswordPlaceholder: 'Huidig wachtwoord',
    newPasswordPlaceholder: 'Nieuw wachtwoord',
    confirmPasswordPlaceholder: 'Bevestig nieuw wachtwoord',
    enterYourPassword:
      'Voer je huidige wachtwoord in om een nieuw wachtwoord in te stellen',
    modifyYourPassword: 'Wijzig je wachtwoord',
    contactUs: 'Neem contact op',
    FAQ: 'Veelgestelde vragen',
    legal: 'Algemene Voorwaarden',
    communicationPreferences: {
      menuItem: 'Communicatievoorkeuren',
      title: 'Communicatievoorkeuren',
      loading: 'Laden…',
      sectionDealsTitle: 'Travelski-aanbiedingen',
      sectionDealsIntro:
        'Exclusieve kortingen, vroegboekvoordelen en prijsverlagingen. Uitschrijven kan op elk moment.',
      sectionPartnersTitle: 'Voordelen van onze partners',
      sectionPartnersIntro: `Nieuws, inspiratie en exclusieve voordelen van de partners van Compagnie des Alpes en Travelski. Om onze communicatie relevanter te maken, kunnen we meten of e-mails worden geopend. Alle berichten worden verzonden door Travelski. Je gegevens blijven bij ons en worden nooit gedeeld met ${partnersLink}, zoals Futuroscope, Les Arcs of La Plagne.`,
      sectionTrackingTitle: 'Gepersonaliseerde e-mails',
      sectionTrackingIntro:
        'Door het gebruik van trackingpixels kunnen we vaststellen of een e-mail werd geopend. Zo beperken we onnodige herinneringen, stemmen we onze communicatie beter af op je interesses en meten we de prestaties van onze campagnes. Je kunt deze toestemming op elk moment met één klik intrekken via een nieuwsbrief of je klantenzone.',
      switchEmail: 'E-mail',
      switchEmailDesc:
        'Het ideale kanaal om aanbiedingen, nieuwtjes en prijsalerts te ontvangen.',
      switchTracking: 'E-mailtracking',
      switchTrackingDesc:
        'Meten of een e-mail geopend werd via een trackingpixel.',
      switchPartenaires: 'Partnercommunicatie (e-mail)',
      switchPartenairesDesc: `Ontvang exclusieve aanbiedingen en nieuws van ${partnersLink}. Alle communicatie wordt verzonden door Travelski. Je gegevens blijven bij ons en worden niet gedeeld met ${partnersLink}.`,
      switchSms: 'SMS',
      switchSmsDesc:
        'Korte herinneringen en belangrijke updates over je boeking of aanbiedingen.',
      save: 'Opslaan',
      back: 'Terug',
    },
    editInfoForm: {
      infoTitle: 'Uw informatie',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      email: 'E-mail',
      emailChangeInfo:
        'Uw e-mailadres kan niet worden gewijzigd omdat het is gekoppeld aan uw dossier en klantenaccount.',
      contactsTitle: 'Contactgegevens',
      address: 'Adres',
      city: 'Stad',
      postalCode: 'Postcode',
      country: 'Land',
      save: 'Wijzigingen opslaan',
      phoneCode: 'Landcode',
      phoneNumber: 'Telefoonnummer',
    },
  },
  global: {
    pageTitle: "Klantaccount"
  }
}

export default translations
